'use es6';

import { Component } from 'react';
import ErrorPagePortal from 'ContentEditorUI/components/app/ErrorPagePortal';
import NotFoundPage from 'ContentEditorUI/components/app/NotFoundPage';
import { jsx as _jsx } from "react/jsx-runtime";
class NotFoundPagePortal extends Component {
  render() {
    return /*#__PURE__*/_jsx(ErrorPagePortal, {
      children: /*#__PURE__*/_jsx(NotFoundPage, {})
    });
  }
}
export default NotFoundPagePortal;